import { CatButton } from '@blocks-react/components/Button';

interface DealerLocatorCancelButtonProps {
  children: React.JSX.Element | string;
  onCancel: () => void;
  isDisabled?: boolean;
}

export const DealerLocatorCancelButton = ({
  children,
  onCancel,
  isDisabled,
}: DealerLocatorCancelButtonProps) => (
  <CatButton
    onClick={onCancel}
    type="button"
    variant="ghost"
    disabled={isDisabled}
  >
    {children}
  </CatButton>
);
